import 'App/pages/Media/Lightbox.css';
import linkResolver from 'prismic-configuration.js';
import { RichText } from 'prismic-reactjs';
import { useState, useEffect, useCallback } from 'react';
// import { PropTypes } from 'prop-types';

function Hero(props) {
  const [transform, setTransform] = useState(0);
  const [opacityChange, setOpacityChange] = useState(1);
  const {
    slice: {
      primary: {
        header, subheader, image:
    { url, mobile: { url: mUrl } },
      },
    },
  } = props;
  const calculatedURL = window.innerWidth >= 768 ? url : mUrl;
  const handleScroll = useCallback((event) => {
    const { scrollTop } = event.srcElement;
    const currentOpacity = 1 - scrollTop / 100;
    const { slice: { primary: { hero_type: heroType } } } = props;
    setTransform(scrollTop);
    if (
      ((opacityChange !== currentOpacity
        && opacityChange > 0)
        || currentOpacity > 0)
      && heroType === 'disappear on scroll'
    ) {
      setOpacityChange(currentOpacity);
    }
    const { isSolid } = props;
    isSolid(transform >= 318);
  }, [opacityChange, transform, props]);

  useEffect(() => {
    document.addEventListener('scroll', handleScroll, true);

    return () => {
      document.removeEventListener('scroll', handleScroll, true);
    };
  }, [handleScroll]);

  return (
    <section
      className="brinker-header-module chilis hero company-page-content"
      style={{
        backgroundImage: `url(${calculatedURL})`,
      }}
    >
      <div className="overlay" />
      <div
          // NOTE:unnote for scroll based opacity header text.
          // Maybe need to be optimized/ find a better method
        style={{ opacity: opacityChange }}
        className="hero-text"
      >
        <div className="grid">
          <div className="text-center header">
            {RichText.render(header, linkResolver)}
          </div>
          <div className="subheader">
            {RichText.asText(subheader) !== '' && (
            <div className="row mx-4">
              <div className="col-1 blueline mt-4" />
              <div className="col-11">
                {RichText.render(
                  subheader,
                  linkResolver,
                )}
              </div>
            </div>
            )}
            <div />
          </div>
        </div>
      </div>
    </section>
  );
}
// Hero.defaultProps = {
//   slice: {},
//   isSolid: () => false,

// };
// Hero.propTypes = {
//   slice: PropTypes.shape({
//     primary: PropTypes.shape({
//       hero_type: PropTypes.string,
//       header: PropTypes.arrayOf(PropTypes.shape({})),
//       subheader: PropTypes.arrayOf(PropTypes.shape({})),
//       image: PropTypes.shape({ url: PropTypes.string }),

//     }),
//   }),
//   isSolid: PropTypes.func,
// };

export default Hero;
